import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.guitarbat": ["Gitar med balltre"] }, "en": { "icon.title.guitarbat": ["Guitar with a bat"] }, "fi": { "icon.title.guitarbat": ["Kitara ja pes\xE4pallomaila"] }, "da": { "icon.title.guitarbat": ["Guitar med et bat"] }, "sv": { "icon.title.guitarbat": ["Gitarr med basebolltr\xE4"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconGuitarBat42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Guitar with a bat`, id: "icon.title.guitarbat", comment: "Title for GuitarBat icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.743 20.326a1.625 1.625 0 0 1 1.343-1.789 3.26 3.26 0 0 0 1.797-.9c1.587-1.585 1.191-4.556-.888-6.632-2.079-2.077-5.047-2.475-6.633-.888a3.26 3.26 0 0 0-.9 1.796 1.625 1.625 0 0 1-1.788 1.344 5.13 5.13 0 0 0-4.311 1.352c-2.221 2.22-1.777 6.266.995 9.033s6.816 3.213 9.036.992a5.13 5.13 0 0 0 1.35-4.308ZM29.74 2.962l-1.723 1.724a1.625 1.625 0 0 0 2.298 2.298L32.04 5.26a1.625 1.625 0 1 0-2.298-2.298Zm-1.723 4.021-4.021 4.022m4.594-9.192 1.15 1.149m2.298 2.298 1.15 1.15m-2.874.573 1.15 1.15m-4.597-4.597 1.15 1.15"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.973 16.652a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25m-6.319 2.396 2.298 2.298m2.331-14.649-2.949-3.53a3.677 3.677 0 1 0-5.167 5.168l2.708 2.274m12.77 10.698 1.866 1.562-.542.542a1.625 1.625 0 1 0 2.3 2.299l3.446-3.447a1.626 1.626 0 0 0-2.299-2.3l-.581.584-1.4-1.672"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-guitar-bat-42")) {
  customElements.define("fp-icon-guitar-bat-42", IconGuitarBat42);
}
export {
  IconGuitarBat42
};
